/** Desenvuelve respuestas Vault/API (FastAPI directo, gateway Nebula, axios legacy). */

function asRecord(value: unknown): Record<string, unknown> | null {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : null;
}

/** Objeto usuario / tenant (`auth/me`, filas anidadas). */
export function unwrapVaultApiRecord(raw: unknown): Record<string, unknown> | null {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) {
    return null;
  }
  const root = raw as Record<string, unknown>;
  if (Array.isArray(root['tenants']) || root['email'] != null || root['id'] != null) {
    return root;
  }
  for (const key of ['data', 'content', 'result', 'user'] as const) {
    const nested = root[key];
    const record = asRecord(nested);
    if (!record) continue;
    if (Array.isArray(record['tenants']) || record['email'] != null || record['id'] != null) {
      return record;
    }
  }
  const response = root['response'];
  if (response && typeof response === 'object') {
    const content = (response as Record<string, unknown>)['content'];
    const record = asRecord(content);
    if (record) return record;
  }
  return root;
}

/** Listas (`my-tenants`, `admin/tenants`, permisos). */
export function unwrapVaultApiArray(raw: unknown): unknown[] {
  if (Array.isArray(raw)) return raw;
  if (!raw || typeof raw !== 'object') return [];

  const root = raw as Record<string, unknown>;
  for (const key of ['data', 'content', 'items', 'results', 'tenants'] as const) {
    const value = root[key];
    if (Array.isArray(value)) return value;
  }

  const response = root['response'];
  if (response && typeof response === 'object') {
    const content = (response as Record<string, unknown>)['content'];
    if (Array.isArray(content)) return content;
    const record = asRecord(content);
    if (record) {
      for (const key of ['data', 'items', 'results', 'tenants'] as const) {
        const value = record[key];
        if (Array.isArray(value)) return value;
      }
    }
  }

  const record = unwrapVaultApiRecord(raw);
  if (record && Array.isArray(record['tenants'])) {
    return record['tenants'] as unknown[];
  }

  return [];
}

export function extractAuthMeTenantsArray(raw: unknown): unknown[] {
  const record = unwrapVaultApiRecord(raw);
  if (!record) return unwrapVaultApiArray(raw);
  const tenants = record['tenants'];
  return Array.isArray(tenants) ? tenants : [];
}
